<template>
  <div class="h-100">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    />
    <main role="main">
      <validation-observer v-slot="{ handleSubmit }" class="w-100">
        <b-form class="submit-form" @submit.prevent="handleSubmit(settingUpdate)">
          <div class="card_wrap">
            <div class="generalSetting">
              <h3 class="generalSetting__header">システムの表示名</h3>
              <h4 class="generalSetting__hubBaseTitle">
                このシステムの名称
                <img
                  v-b-tooltip.hover.top.html="{
                    variant: 'secondary',
                    animation: true
                  }"
                  title="設定した名称はヘッダーなどに表示されます。担当エリアなどの識別にご利用ください。"
                  src="../assets/images/help_outline_gray_24dp.svg"
                  alt="Question mark"
                  class="question_mark"
                />
                <span class="required d-flex align-items-center">必須</span>
              </h4>
              <ValidationProvider
                name="+Hub BASE"
                mode="passive"
                rules="required"
                v-slot="{ errors }"
              >
                <input-text-component
                  class="form-control text_gray"
                  id="system-name"
                  v-model="request.mstSetting.isName"
                  :state="errors && errors.length ? true : false"
                  :maxlength="32"
                  @blur="cleanValidity('system-name')"
                />
                <small class="text-danger mb-1 p-0" v-for="(error, i) in errors" :key="i">
                  {{ errors[i] }}
                </small>
              </ValidationProvider>
              <h4 class="generalSetting__companyName" style="margin-top: 8px;">
                +Hub BASEと繋ぐシステムの名称（または社名）
                <img
                  v-b-tooltip.hover.top.html="{
                    variant: 'secondary',
                    animation: true
                  }"
                  :title="`貴社のシステム表示名称を設定してください。名称がない、連携をしない場合は社名を設定してください。`"
                  src="../assets/images/help_outline_gray_24dp.svg"
                  alt="Question mark"
                  class="question_mark"
                />
                <span class="required d-flex align-items-center">必須</span>
              </h4>
              <ValidationProvider
                name="社名"
                mode="passive"
                rules="required"
                v-slot="{ errors }"
              >
                <input-text-component
                  id="company-name"
                  class="form-control text_gray"
                  v-model="request.mstSetting.wmsName"
                  :state="errors && errors.length ? true : false"
                  :maxlength="32"
                  @blur="cleanValidity('company-name')"
                />
                <small class="text-danger mb-1 p-0" v-for="(error, i) in errors" :key="i">
                  {{ errors[i] }}
                </small>
              </ValidationProvider>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <b-button variant="info" class="saveButton" type="submit">保存</b-button>
          </div>
        </b-form>
      </validation-observer>
    </main>
  </div>
</template>
<script>
import FlashMessage from '../common/flash-message.component'
import Loading from 'vue-loading-overlay'
import { mapActions, mapGetters } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import InputTextComponent from '../components/custom-components/InputTextComponent.vue'
export default {
  data() {
    return {
      request: {},
      isLoading: false
    }
  },
  components: {
    Loading,
    ValidationProvider,
    ValidationObserver,
    InputTextComponent
  },
  created() {
    this.$_fetch_setting()
  },
  methods: {
    ...mapActions('setting', ['insertSetting']),
    ...mapGetters('setting', ['getSetting']),
    ...mapGetters('subMenus', ['getPageTitleRoute']),
    ...mapActions('subMenus', ['addChildrenRoute']),
    async settingUpdate() {
      await this.$_update_setting()
      this.$grobalListener.$emit('getHeaderTitle')
    },
    /**
     * 設定データ取得
     */
    $_fetch_setting() {
      const results = this.getSetting()
      if (results && results.data) {
        this.request = results.data
      } else {
        FlashMessage.getInstance().showErrorMessage('データのフェッチに失敗しました。')
      }
    },
    /**
     * 設定データ更新
     */
    async $_update_setting() {
      this.isLoading = true
      try {
        // アップデート処理開始
        const response = await this.$axios.put('/setting', this.request)
        await this.insertSetting(response)
        FlashMessage.getInstance().showSuccessMessage('正常に保存できました。')
      } catch (error) {
        console.log(error)
        this.isLoading = false
        FlashMessage.getInstance().showErrorMessage('登録失敗。')
      }
      this.isLoading = false
    },
    cleanValidity(id) {
      const input = document.getElementById(id)
      if (!input.checkValidity()) {
        input.setCustomValidity('')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
main {
  .card_wrap {
    margin-bottom: 16px;
  }
  .generalSetting {
    height: auto;
    width: auto;
    margin: 22px;
    margin-left: 62px !important;
    &__header {
      font-weight: bold;
      @include responsive-fs(20);
      margin-bottom: 24px;
    }
    &__companyName {
      display: flex;
      align-items: center;
      font-weight: bold;
      @include responsive-fs(16);
      color: #666563;
      margin-bottom: 8px !important;
    }
    &__hubBaseTitle {
      display: flex;
      align-items: center;
      font-weight: bold;
      @include responsive-fs(16);
      color: #666563;
      margin: 8px 0 !important;
    }
  }
  .saveButton {
    padding: 8px 16px;
    border-radius: 4px;
    min-height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    @include responsive-fs(18);
  }
  .scrollable-card {
    // 50px = Height of save button container
    height: calc(100% - 50px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GeneralSetting.vue